
import dust from "dustjs-linkedin";


(function(){dust.register("account/subscription/upsell",body_0);function body_0(chk,ctx){return chk.write("<a class=\"upsell-button\" data-action=\"subscribe\"><div class=\"text\"><h1>").reference(ctx.getPath(false, ["upsell","title"]),ctx,"h").write("</h1><p>").reference(ctx.getPath(false, ["upsell","message"]),ctx,"h").write("</p></div><div class=\"arrow\">").helper("svg",ctx,{},{"path":"arrow"}).write("</div></a>");}return body_0;})();

export default 0;
